export default __webpack_public_path__ + "static/smp-meshery-eddb57a9e50c6743e4308232e73ca1e7.webp";